import type { StrictOmit } from '@frontend/duck-tape';
import type { LoaderProps as MLoaderProps } from '@mantine/core';
import { Loader as MLoader } from '@mantine/core';

export type SpinnerProps = StrictOmit<MLoaderProps, 'classNames'>;

export const Spinner = ({ ...props }: SpinnerProps) => {
  return <MLoader color="cream.0" {...props} />;
};
